import HeaderGeneric from "../../components/generic/headerGeneric";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
//import '@progress/telerik-react-report-viewer/dist/es/telerikReportViewer.css';
import { urlTelerik } from "../../services/http-common";
import themeBase from "../../utils/theme/themeBase";
import HeaderTable from "../../components/generic/HeaderTable";
import { ICommandBarItemProps, Stack } from "@fluentui/react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import TokenService from "../../services/tokenService";
import { keyAccess } from "../../utils/helpers/helpers";
import AuthService from "../../services/authService";
import IconHelper from "../../utils/helpers/iconHelper";
import TablaReporte from "../../components/Table/TablaReporte";
import reporteServicio from "../../services/reporteService";
import { IExportarReporte } from "../../Interfaces/base/IBase";

let title: string = "Cuadro de Mando IPERC";
let subTitle: string = "Visualice los indicadores clave en el módulo IPERC";
// let subTitle2: string = "Tome decisiones sobre el trabajo en tiempo real."
let Parameters = {};
function MandoIPERC() {
  // let t = TokenService.getToken();
  // const viewerRef = useRef();

  // const viewerOptions = {
  //   serviceUrl: urlTelerik,
  //   reportSource: {
  //     parameters: { editors: { multiSelect: { ...Parameters } } },
  //     report: 'CMIPERC.trdx',
  //   },
  //   viewMode: 'INTERACTIVE',
  //   scaleMode: 'FIT_PAGE_WIDTH',
  //   scale: 1.0,
  //   enableAccessibility: false,
  //   toolbar: {
  //     items: {
  //       export: {
  //         visible: false
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {
  //   EnviarToken();
  // }, [t]);

  // const EnviarToken = () => {
  //   var { viewerObject } =
  //     viewerRef.current != null ? viewerRef.current : viewerObject;
  //   viewerObject.authenticationToken(t);
  // };

  // useEffect(() => {
  //   fetch(`${urlTelerik}/version`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${TokenService.getToken()}`,
  //     },
  //   })
  //     .then((response) => {
  //       //alert("Error telerick ...");
  //       //console.log("Código de estado:", response.status);
  //       if (response.status === 401 || response.status === 403) {
  //         localStorage.removeItem(keyAccess);
  //         AuthService.removeToken();
  //         window.location.assign("/login");
  //       }
  //       if (response.ok) {
  //         response.json().then((data) => {
  //           console.log("Datos de la respuesta:", data);
  //         });
  //       } else {
  //         console.error("Error al realizar la solicitud:", response.statusText);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error de red:", error);
  //     });
  // }, []);

  const urlTelerikR = `${urlTelerik}/reports`;
  let t = TokenService.getToken();
  let viewerRef;
  // const urlTelerikR = `${urlTelerik}/reports`;
  const templateUrlf = "template.html/"
  const reporteName = 'CMIPERC.trdx'
  const Parameters = { /* tus parámetros aquí */ };
  const viewerContainerStyle1 = {
    position: 'absolute',
    left: '5px',
    right: '5px',
    top: '40px',
    bottom: '5px',
    overflow: 'hidden',
    clear: 'both',
    fontFamily: 'ms sans serif'
  }

  const viewerOptions = {
    serviceUrl: urlTelerikR,
    templateUrl: templateUrlf,
    reportSource: {
      parameters: { editors: { multiSelect: { ...Parameters } } },
      report: reporteName,
    },
    viewerContainerStyle: viewerContainerStyle1,
    viewMode: 'INTERACTIVE',
    // scaleMode: 'SPECIFIC',
    scaleMode: 'FIT_PAGE_WIDTH',
    scale: 1.0,
    enableAccessibility: false,
    toolbar: {
      items: [
        {
          type: 'togglePrintPreview',
          text: 'Print',
          visible: true
        },
        {
          type: 'export',
          text: 'Export',
          visible: false
        }
      ]
    },
    // ready: function () {
    //   //this.refreshReport();
    // }
  };

  const recargarPagina = () => {
    window.location.reload();
  };

  const [key, setKey] = useState(0);

  // Función para recargar el componente
  const recargarComponente = () => {
    setKey(prevKey => prevKey + 1);
  };

  function descargarReporte() {
    // setCargaTabla(true);
    // setCargaSpinner(true);
    // controllerRef.current.abort();
    // const newController = new AbortController();
    // controllerRef.current = newController;
    const reporteExportar: IExportarReporte = {
      report: reporteName,
      Extension: "PDF"
    }
    reporteServicio.exportaReporte(reporteExportar)

      .then((response) => {
        if (response.status === 200) {
          // response.json().then((data) => {
          //   console.log("Datos de la respuesta:", data);
          // });
          console.log("Datos de la respuesta: Reporte generado ----");
          console.log(response.data);

          const dataUrl = response.data;

          // Create a link element
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'reporteCM'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

          // Simulate a click on the link to trigger the download
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }
        else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // useEffect(() => {
  //   fetch(`${urlTelerikR}/version`, {
  //     method: "GET",
  //     headers: {
  //       Authorization: `Bearer ${TokenService.getToken()}`,
  //     },
  //   })

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      // onClick: (arg) => actualizarTabla(),
      // onClick: () => viewerRef.refreshReport(),
      onClick: recargarComponente,
    }
  ];

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        //navigate(`reporteHistoricoC`);
        descargarReporte();
      },
      // onClick: openReporte,
    },
    // {
    //   key: "reporte",
    //   text: `${isFilter ? "Limpiar Filtro" : "Filtrar"}`,
    //   iconProps: { iconName: `${isFilter ? "clearfilter" : "filter"}` },
    //   onRenderIcon() {
    //     return IconHelper.ICONFILTER;
    //   },
    //   onClick: openFiltros,
    // },
  ];

  // useEffect(() => {
  //   if (viewerRef.current && viewerRef.current.viewer) {
  //     viewerRef.current.viewer.setOptions(viewerOptions);
  //     viewerRef.current.viewer.refreshReport();
  //   }
  // }, []);

  // useEffect(() => {
  //   if (viewerRef.current) {
  //     const viewer = viewerRef.current;
  //     viewer.addEventListener('viewerRendered', () => {
  //       const exportButton = viewer.toolbar.container.querySelector("[data-command='Export']");
  //       if (exportButton) {
  //         exportButton.style.display = 'none';
  //       }
  //     });
  //   }
  // }, [viewerRef]);

  // useLayoutEffect(() => {
  //   const exportButton = document.querySelector("#trv-main-menu-export-command");
  //   if (exportButton !== null) {
  //     console.log(exportButton)

  //   }
  //   if (viewerRef.current) {
  //     //console.log(exportButton)


  //     const interval = setInterval(() => {
  //       const viewer = viewerRef.current;
  //       if (viewer && viewer.toolbar) {
  //         const exportButton = document.querySelector("#trv-main-menu-export-command");
  //         console.log(exportButton)
  //         if (exportButton) {
  //           //exportButton.style.display = 'none';
  //           clearInterval(interval);
  //         }
  //       }
  //     }, 100); // Chequea cada 100 ms hasta que el botón sea encontrado y ocultado
  //   }
  // }, [viewerRef]);

  // useEffect(() => {
  //   const hideExportButton = () => {
  //     if (viewerRef.current) {
  //       // const exportButton = viewerRef.current.querySelector("[data-command='Export']");
  //       const exportButton = viewerRef.current.querySelector("#trv-main-menu-export-command");
  //       if (exportButton) {
  //         exportButton.style.display = 'none';
  //       }
  //     }
  //   };

  //   // Intenta ocultar el botón inmediatamente después de montar el componente
  //   hideExportButton();

  //   // Reintenta después de un breve retraso para asegurarse de que el DOM esté completamente cargado
  //   const timeout = setTimeout(hideExportButton, 500);

  //   return () => clearTimeout(timeout);
  // }, [viewerRef]);

  // ---> 
  useEffect(() => {
    const hideExportButton = () => {
      const exportButton: any = document.querySelector("#trv-main-menu-export-command");
      // console.log(exportButton)

      if (exportButton) {
        // console.log(exportButton)
        exportButton.remove();
        // exportButton.style.display = 'none';
        clearInterval(interval);
      }
    };

    // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
    const interval = setInterval(hideExportButton, 1);

    // Limpia el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, [key]);

  return (
    <>
      {/* <HeaderGeneric
                title={title}
                subTitle={subTitle}
                subTitle2={subTitle2}
            // sizeTitles={{first:22,second:10,third:9}}
            /> */}

      <Stack padding={10}>
        {/* <HeaderTable */}
        <TablaReporte
          title={title}
          subTitle={subTitle}
          rigthBar={_farItems}
          leftBar={_items}
          horizontalAlign="start"
          // horizontalAlign="end"
          iconName="BarChartVerticalFill"
        />
      </Stack>

      {/* <TelerikReportViewer
        // ref={e => viewer = e}
        ref={viewerRef}
        serviceUrl={urlTelerikR}
        reportSource={{
          parameters: { editors: { multiSelect: { ...Parameters } } },
          report: "CMIPERC.trdx",
        }}

        viewerContainerStyle={themeBase.telerikStyle}
        viewMode="INTERACTIVE"
        scaleMode="FIT_PAGE_WIDTH"
        scale={1.0}
        enableAccessibility={false}
        toolbarItems={viewerOptions.toolbar.items} // Aquí se pasa la configuración de la toolbar
      /> */}
      {/* <button id="refresh-button" className="k-button" onClick={() => viewerRef.refreshReport()}>Refresh</button> */}
      {/* <button onClick={() => viewerRef.commands.print.exec()}>Print</button> */}
      <div key={key}>
        {/* sxd <div key={key}> */}
        <TelerikReportViewer
          ref={el => viewerRef = el}
          serviceUrl={viewerOptions.serviceUrl}
          //templateUrl={viewerOptions.templateUrl}
          reportSource={viewerOptions.reportSource}
          viewerContainerStyle={{ ...themeBase.telerikStyle }}
          // viewerContainerStyle={viewerOptions.viewerContainerStyle}
          viewMode={viewerOptions.viewMode}
          scaleMode={viewerOptions.scaleMode}
          scale={viewerOptions.scale}
          enableAccessibility={viewerOptions.enableAccessibility}
          authenticationToken={t}
          toolbarItems={viewerOptions.toolbar.items} // Aquí se pasa la configuración de la toolbar
        />
      </div>

    </>
  );
}

export default MandoIPERC;
